// The Insights question limit, as plain functions (LO-222).
//
// The screen is `InsightsAskLimits` in People.jsx; what it decides lives here so a test can hold it. The figures
// are a count of questions a person may put to the model in a UTC day, and the kernel is what holds the bounds,
// so the screen reads them from the answer and names none of its own.

/** A figure is a whole number inside the kernel's bounds. */
export function validPerDay(value, bounds) {
  if (value === "" || value === null || value === undefined) return false;
  const n = Number(value);
  return Number.isInteger(n) && n >= bounds.min && n <= bounds.max;
}

/** Which figure applies to somebody, and whose decision it is. */
export function figureFor(limits, username) {
  const own = (limits.people || []).find((p) => p.username === String(username || "").trim().toLowerCase());
  if (own) return { per_day: own.per_day, source: "person", by: own.set_by };
  if (limits.default) return { per_day: limits.default.per_day, source: "default", by: limits.default.set_by };
  return { per_day: limits.built_in_per_day, source: "built_in", by: "" };
}

/** `their own, set by a@x`, `the limit for everybody, set by a@x` or `the built-in limit: nobody has set one`. */
export function whose(figure) {
  if (figure.source === "person") return `their own, set by ${figure.by || "a governor"}`;
  if (figure.source === "default") return `the limit for everybody, set by ${figure.by || "a governor"}`;
  return "the built-in limit: nobody has set one";
}

/** Whether a failure is one that means this screen is not for the person, which is said by saying nothing. */
export function isNotForThem(error) {
  const code = error?.body?.error;
  return code === "not_a_governor" || code === "not_in_manifest" || error?.status === 404 || error?.status === 403;
}

/** An address a person's own limit can be set for: an email, with nothing the kernel would refuse. */
export function validAddress(value) {
  const v = String(value || "").trim().toLowerCase();
  return Boolean(v) && v.includes("@") && !v.includes("#") && v.length <= 200;
}
